import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
const styles = theme => ({
  grid: {
    paddingLeft: 15,
    paddingRight: 15,
    [theme.breakpoints.up("sm")]: {
      width: 570
    },
    [theme.breakpoints.up("md")]: {
      width: 930
    },
    [theme.breakpoints.up("lg")]: {
      width: 1200,
    }
  }
});
const GridContainer = ({ children, classes, justify }) => {
  return (
    <Grid container justify="center">
      <Grid
        container
        className={classes.grid}
        // justify={justify === null ? 'center' : justify}
      >
        {children}
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(GridContainer);
